import { useState } from 'react';
import { versionsData, versionTabs } from '@/mocks/homeData';

export default function VersionExplorer() {
  const [activeTab, setActiveTab] = useState(versionTabs[0].id);
  const active = versionsData.find((item) => item.tab === activeTab) ?? versionsData[0];

  return (
    <section id="versions" className="w-full scroll-mt-28 bg-background-100 py-14 md:py-20">
      <div className="mx-auto w-full max-w-[1240px] px-4 md:px-6">
        <div className="max-w-2xl">
          <span className="font-label text-xs font-medium uppercase tracking-widest text-primary-600">
            Versions
          </span>
          <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            版本速览：先弄清你要的是哪一版
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
            中文版、国语版、中文字幕、字幕在线听起来接近，其实侧重点不同。切换下面的标签，
            可以分别了解每个方向解决的问题与适合的人群。
          </p>
        </div>

        <div className="mt-8 inline-flex flex-wrap gap-1 rounded-full border border-background-200 bg-background-50 p-1">
          {versionTabs.map((tab) => (
            <button
              key={tab.id}
              type="button"
              onClick={() => setActiveTab(tab.id)}
              aria-pressed={activeTab === tab.id}
              className={`cursor-pointer whitespace-nowrap rounded-full px-4 py-2 font-label text-sm transition-colors ${
                activeTab === tab.id
                  ? 'bg-primary-500 text-background-50'
                  : 'text-foreground-600 hover:bg-background-100 hover:text-foreground-900'
              }`}
            >
              {tab.label}
            </button>
          ))}
        </div>

        <div className="mt-6 grid grid-cols-1 gap-6 lg:grid-cols-5">
          <div className="lg:col-span-3">
            <article className="flex h-full flex-col rounded-lg border border-background-200 bg-background-50 p-6 md:p-8">
              <div className="flex flex-wrap items-center gap-3">
                <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-100 px-3 py-1 font-label text-xs font-medium text-accent-900">
                  <i className="ri-bookmark-3-line text-sm" aria-hidden="true"></i>
                  {active.badge}
                </span>
                <span className="text-xs text-foreground-500">{active.tagline}</span>
              </div>

              <h3 className="mt-4 font-heading text-xl font-bold text-foreground-950 md:text-2xl">
                {active.name}
              </h3>
              <p className="mt-3 text-sm leading-relaxed text-foreground-700">{active.description}</p>

              <ul className="mt-6 space-y-3 border-t border-background-200 pt-6">
                {active.features.map((feature) => (
                  <li key={feature} className="flex items-start gap-3 text-sm text-foreground-700">
                    <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-secondary-100 text-secondary-700">
                      <i className="ri-check-line text-sm" aria-hidden="true"></i>
                    </span>
                    {feature}
                  </li>
                ))}
              </ul>

              <div className="mt-6 flex items-start gap-3 rounded-md bg-secondary-50 p-4">
                <i
                  className="ri-user-heart-line mt-0.5 text-lg text-secondary-600"
                  aria-hidden="true"
                ></i>
                <p className="text-sm text-secondary-900">
                  <span className="font-medium">适合：</span>
                  {active.bestFor}
                </p>
              </div>
            </article>
          </div>

          <div className="lg:col-span-2">
            <div className="relative h-56 w-full overflow-hidden rounded-lg md:h-full md:min-h-[320px]">
              <img
                src="https://readdy.ai/api/search-image?query=Warm%20terracotta%20and%20amber%20abstract%20texture%20with%20soft%20vertical%20bands%2C%20subtle%20paper%20grain%2C%20cinematic%20editorial%20background%2C%20minimal%20and%20calm%20mood%2C%20generous%20negative%20space%2C%20no%20text%2C%20high%20detail&width=900&height=1100&seq=secretary-version-cover&orientation=portrait"
                alt="版本导览配图，暖色调抽象质感"
                className="h-full w-full object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/85 via-foreground-950/30 to-transparent"></div>
              <div className="absolute inset-x-0 bottom-0 p-5">
                <p className="font-heading text-lg font-bold text-background-50">四个方向，一次看懂</p>
                <p className="mt-1 text-xs leading-relaxed text-background-100/85">
                  先确定用途，再选版本，能省下大量来回切换的时间。
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}